module.exports = "<div class=\"form-group\">\r\n    <div *ngIf=\"localFile\">\r\n        <label class='control-label'>Loaded: {{ localFile }}</label>\r\n    </div>\r\n\r\n    <label for=\"file\">{{ fileLegend }}</label>\r\n    <input type=\"file\" id=\"fileLoader\" accept=\"suportedString\" (change)=\"onFileChange($event)\">\r\n    <div class=\"text-danger\" *ngIf=\"!hasValidExtention\">{{ extentionErrorMessage }}</div>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/sxFileImport/fileImport.component.html
// module id = ../../../../../src/app/helpers/components/sxFileImport/fileImport.component.html
// module chunks = main